import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react"
import { Button, Form, Input, Col, Row, Checkbox, Table, message, Popconfirm } from "antd"
import { getPartMaintenList, partMaintenInsert, partMaintenEdit } from "@/service/aiDiagnoseService"

const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    const { t } = useTranslation();
    // console.log(dataIndex)
    const inputNode = inputType === "checkbox" ? <Checkbox defaultChecked={record.selectBoxType} /> : <Input />
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={dataIndex === "componentName" ? [{ required: true, message: `${t(`aiDiagnose.partMaintenance.请输入`)}${title}!` }] : []}
                    // valuePropName={dataIndex === "selectBoxType" ? "checked" : "value"}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    )
}
//部件维护
export default ({ modeKey, dispatch }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        let data = {
            pageSize: 1000,
            pageNum: 1,
            searchItem: {},
            orders: [{ column: "componentSort", rule: "ASC" }],
        }
        getPartMaintenList(data)
            .then((res) => {
                // if (res && res.retCode === 200) {
                    setData(res.retData.list)
                // } else {
                //     message.warning(res.retMsg)
                // }
            })
            // .catch((err) => message.error(err.retMsg))
    }

    //表单提交
    const onSubmit = () => {
        form.validateFields().then((val) => {
            partMaintenInsert(val)
                .then((res) => {
                    // if (res && res.retCode === 200) {
                        form.resetFields()
                        loadData()
                        message.success(t(`aiDiagnose.partMaintenance.部件新增成功`))
                    // } else {
                    //     message.warning(res.retMsg)
                    // }
                })
                // .catch((err) => message.error(err.retMsg))
        })
    }

    const formItemLayout = {
        labelCol: {
            offset: 2,
        },
        wrapperCol: {
            offset: 2,
        },
    }
    //取消
    const handleCancel = () => {
        dispatch({
            type: "removeTabs",
            targetKey: modeKey,
            activeMenu: "aiDiagnose",
        })
    }

    //编辑table 行
    const [editForm] = Form.useForm()
    const [editingKey, setEditingKey] = useState("")
    const isEditing = (record) => record.id === editingKey

    //编辑当前行
    const edit = (record) => {
        editForm.setFieldsValue({
            componentName: "",
            componentExplain: "",
            componentSort: "",
            ...record,
        })
        setEditingKey(record.id)
    }

    const save = async (id) => {
        try {
            const row = await editForm.validateFields()
            const newData = [...data]
            const index = newData.findIndex((item) => id === item.id)
            if (index > -1) {
                // const item = newData[index];
                // newData.splice(index, 1, { ...item, ...row });
                // console.log(newData);
                partMaintenEdit({ ...row, id })
                    .then((res) => {
                        // if (res && res.retCode === 200) {
                            loadData()
                            setEditingKey("")
                            message.success(t(`aiDiagnose.partMaintenance.部件修改成功`))
                        // } else {
                        //     message.warning(res.retMsg)
                        // }
                    })
                    // .catch((err) => message.error(err.retMsg))
            } else {
                newData.push(row)
                setData(newData)
                setEditingKey("")
            }
        } catch (errInfo) {
            console.log("Validate Failed:", errInfo)
        }
    }

    const columns = [
        {
            title: t(`aiDiagnose.partMaintenance.部件名称`),
            align: "center",
            width: 300,
            dataIndex: "componentName",
            editable: true,
        },
        {
            title: t(`aiDiagnose.partMaintenance.部件说明`),
            align: "center",
            dataIndex: "componentExplain",
            editable: true,
        },
        {
            title: t(`aiDiagnose.partMaintenance.部件排序`),
            align: "center",
            width: 150,
            dataIndex: "componentSort",
            editable: true,
        },
        {
            title: t(`aiDiagnose.partMaintenance.操作`),
            width: 200,
            align: "center",
            render: (_, record) => {
                const editable = isEditing(record)
                return editable ? (
                    <>
                        <Button shape="round" className="yc-public-but" onClick={() => save(record.id)}>
                             {t(`aiDiagnose.partMaintenance.保存`)}
                        </Button>
                        <Popconfirm okText= {t(`aiDiagnose.partMaintenance.确认`)} cancelText= {t(`aiDiagnose.partMaintenance.关闭`)} title= {t(`aiDiagnose.partMaintenance.取消将恢复编辑前的值`)} onConfirm={() => setEditingKey("")}>
                            <Button shape="round" className="yc-public-but">
                                 {t(`aiDiagnose.partMaintenance.取消`)}
                            </Button>
                        </Popconfirm>
                    </>
                ) : (
                    <Button shape="round" className="yc-public-but" disabled={editingKey !== ""} onClick={() => edit(record)}>
                         {t(`aiDiagnose.partMaintenance.编辑`)}
                    </Button>
                )
            },
        },
    ]
    const partColumns = columns.map((col) => {
        if (!col.editable) {
            return col
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === "selectBoxType" ? "checkbox" : "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        }
    })
    return (
        <>
            <div className="toolbar">
                <span className="modules-name"> {t(`aiDiagnose.partMaintenance.智能诊断`)}</span>
            </div>
            <div className="list-container">
                <div className="list-header">
                    <div className="list-name">
                        <span> {t(`aiDiagnose.partMaintenance.部件维护详情`)}</span>
                    </div>
                    <div className="list-but">
                        <Button shape="round" className="but-left" onClick={handleCancel}>
                             {t(`aiDiagnose.partMaintenance.返回`)}
                        </Button>
                        <Button shape="round" className="but-left" onClick={onSubmit}>
                             {t(`aiDiagnose.partMaintenance.添加`)}
                        </Button>
                    </div>
                </div>
                <div className="form-details-warp">
                    <Form  layout="vertical" form={form} {...formItemLayout}>
                        <Row>
                            <Col span={6} xxl={4}>
                                <Form.Item
                                    label= {t(`aiDiagnose.partMaintenance.部件名称`)}
                                    name="componentName"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(`aiDiagnose.partMaintenance.该项为必填`),
                                        },
                                    ]}
                                >
                                    <Input placeholder= {t(`aiDiagnose.partMaintenance.部件名称`)} />
                                </Form.Item>
                            </Col>
                            <Col span={6} xxl={4}>
                                <Form.Item
                                    label= {t(`aiDiagnose.partMaintenance.部件排序`)}
                                    name="componentSort"
                                    rules={[
                                        {
                                            required: false,
                                            message: t(`aiDiagnose.partMaintenance.该项为必填`),
                                        },
                                        // {
                                        //     pattern: /^\d+$/,
                                        //     message: t(`aiDiagnose.partMaintenance.请填写整数`),
                                        // },
                                    ]}
                                >
                                    <Input placeholder= {t(`aiDiagnose.partMaintenance.部件排序`)} />
                                </Form.Item>
                            </Col>
                            <Col span={12} xxl={8}>
                                <Form.Item label= {t(`aiDiagnose.partMaintenance.部件说明`)} name="componentExplain" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                                    <Input placeholder= {t(`aiDiagnose.partMaintenance.部件说明`)} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            <div className="list-container">
                <div className="list-header">
                    <div className="list-name">
                        <span> {t(`aiDiagnose.partMaintenance.部件列表`)}</span>
                    </div>
                </div>
                <Form  layout="vertical" form={editForm} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        size="small"
                        scroll={{ y: 500 }}
                        rowKey={(record) => record.id}
                        dataSource={data}
                        columns={partColumns}
                        rowClassName="editable-row"
                        pagination={false}
                    />
                </Form>
            </div>
        </>
    )
}
